import { RootState } from "@/store";
import { useAppSelector } from "@/store/hooks";
import { useTranslation } from "next-i18next";
import { Button } from "antd";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import DonationInfoConfirmModal from "./DonationInfoConfirmModal";
import { IAwardInfo } from "@/props/IDonation";
import TipModal from "../Modal/TipModal";
import Icon from "../Icon";
import { saveAward } from "@/api/donation";

const RewardWall = ({ awardInfo }: { awardInfo: IAwardInfo }) => {
  const { isMobile } = useAppSelector((state: RootState) => state.app);
  const [confirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);
  const { t } = useTranslation();
  const [canEdit, setCanEdit] = useState(false);
  const tipMmodalRef = useRef();
  const [tipTitle, setTipTitle] = useState("");
  const [tipDesc, setTipDesc] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (awardInfo) {
      setCanEdit(!awardInfo.isSubmit);
    }
  }, [awardInfo]);

  const handleSure = async (values) => {
    try {
      await saveAward(values);
      setTipTitle(t("csr.submit_success"));
      setTipDesc(t("csr.success_info"));
      setSuccess(true);
      setCanEdit(false);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
      setTipTitle(t("csr.submit_fail"));
      setTipDesc(t("csr.fail_info"));
      setSuccess(false);
    }
    (tipMmodalRef.current as any)?.setOpen(true);
  };

  return (
    <div
      className={`max-w-[1440px] items-stretch justify-center ${
        isMobile ? "mx-4 mb-10 flex-col" : " m-auto mt-32 flex"
      }`}
    >
      <Image
        src="/images/csr/reward_wall.webp"
        className="rounded-md object-cover"
        alt="reward wall"
        width={642}
        height={392}
      />
      <div className={`flex flex-1 flex-col justify-between ${isMobile ? "mt-6 items-center" : "ml-6 h-[392px]"}`}>
        <h3 className={`font-semibold text-stone-800 ${isMobile ? "mb-6 h-[48px] text-2xl" : "h-[60px] text-5xl"}`}>
          {t("csr.reward_wall_title")}
        </h3>
        <p className={`text-stone-900 ${isMobile ? "text-sm" : "text-xl"}`}>
          {t("csr.reward_wall_desc_1")}
          <span className={`block ${isMobile ? "my-6" : "mt-10"}`}>{t("csr.reward_wall_desc_2")}</span>
        </p>
        {canEdit ? (
          <Button
            type="primary"
            className="w-[320px] cursor-pointer text-base"
            onClick={() => {
              setConfirmModalOpen(true);
            }}
            style={{ height: "56px" }}
          >
            {t("csr.confirm_info")}
          </Button>
        ) : (
          <span
            className={`cursor-pointer  font-semibold text-primary ${isMobile ? "text-base" : "text-2xl"}`}
            onClick={() => {
              setConfirmModalOpen(true);
            }}
          >
            {t("csr.check_donation_detail")} &gt;{" "}
          </span>
        )}
      </div>
      <DonationInfoConfirmModal
        awardInfo={awardInfo}
        canEdit={canEdit}
        open={confirmModalOpen}
        onModalCancel={() => {
          setConfirmModalOpen(false);
        }}
        onModalSure={(values) => {
          handleSure(values);
        }}
      />
      <TipModal
        width={318}
        onRef={tipMmodalRef}
        icon={<Icon name={success ? "success-big" : "fail"} size={64} />}
        title={tipTitle}
        desc={tipDesc}
        okText={t("common.ok")}
        okCallback={
          success
            ? () => {
                // success 下执行的逻辑
                setConfirmModalOpen(false);
              }
            : undefined // fail 时不提供回调
        }
      />
    </div>
  );
};
export default RewardWall;
